import { createActions } from 'redux-actions';

import { InsurancePolicyUserList } from '@models/InsurancePolicyUser';
import { GetAllInsurancePolicyUserParams, CreateInsurancePolicyUserParams, UpdateInsurancePolicyUserParams } from '@apis/InsurancePolicyUserApi';
import { Pagination } from '@models/Pagination';

export type State = {
  policyUsers?: InsurancePolicyUserList[] | null;
  pagination?: Pagination;
  isLoading?: boolean;
};

export type InsurancePolicyUsersFetchPayload = GetAllInsurancePolicyUserParams;
export type InsurancePolicyUserCreatePayload = CreateInsurancePolicyUserParams;
export type InsurancePolicyUserUpdatePayload = UpdateInsurancePolicyUserParams;
export type StateUpdatePayload = Partial<State>;

export const {
  insurancePolicyUsersFetch,
  insurancePolicyUserCreate,
  insurancePolicyUserUpdate,
  stateUpdate,
  stateClear,
} = createActions(
  'INSURANCE_POLICY_USERS_FETCH',
  'INSURANCE_POLICY_USER_CREATE',
  'INSURANCE_POLICY_USER_UPDATE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  {
    prefix: 'FEATURE_INSURANCE_POLICY_USER',
  },
);
